import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { BuyingACatScreen, BuyingACatScreenProps } from 'shared/screens/buying-a-cat';
import { useLocale } from 'shared/library/i18n/use-locale';

export default function BuyingACat(props: BuyingACatScreenProps) {
  const { t } = useTranslation('screens');
  const { market } = useLocale();

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.forPage(
          t('buying_a_cat.title', { country: market.country_name }),
          t('buying_a_cat.description', { country: market.country_name }),
        )
      }
    >
      <BuyingACatScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(BuyingACatScreen.pageBuilder);
